/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContactStateMachineResponse } from '../models/ContactStateMachineResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminContactStatesService {
    /**
     * Get Contact State Machine
     * Describe the contact state machine for UI option rendering.
     *
     * Without ``campaign_id`` this returns just the immutable defaults. With one,
     * the campaign's configured custom states are appended (``immutable: false``,
     * each carrying its configured ``action`` and admin-assignable from any
     * state). ``rules`` lists every admin-assignable target with its guards
     * (``allowed_from`` of ``null`` means any current state). Transitions out of
     * ``sensitive_source_states`` require an explicit ``reason`` in
     * ``POST /api/admin/contacts/bulk-transition``.
     * @param campaignId
     * @returns ContactStateMachineResponse Successful Response
     * @throws ApiError
     */
    public static getContactStateMachineApiAdminContactStatesMachineGet(
        campaignId?: (string | null),
    ): CancelablePromise<ContactStateMachineResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/contact-states/machine',
            query: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Distinct Contact States
     * @param campaignId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getDistinctContactStatesApiAdminContactStatesDistinctGet(
        campaignId?: (string | null),
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/contact-states/distinct',
            query: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Contact State Machine
     * Describe the contact state machine for UI option rendering.
     *
     * Without ``campaign_id`` this returns just the immutable defaults. With one,
     * the campaign's configured custom states are appended (``immutable: false``,
     * each carrying its configured ``action`` and admin-assignable from any
     * state). ``rules`` lists every admin-assignable target with its guards
     * (``allowed_from`` of ``null`` means any current state). Transitions out of
     * ``sensitive_source_states`` require an explicit ``reason`` in
     * ``POST /api/admin/contacts/bulk-transition``.
     * @param campaignId
     * @returns ContactStateMachineResponse Successful Response
     * @throws ApiError
     */
    public static getContactStateMachineAdminContactStatesMachineGet(
        campaignId?: (string | null),
    ): CancelablePromise<ContactStateMachineResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/contact-states/machine',
            query: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Distinct Contact States
     * @param campaignId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getDistinctContactStatesAdminContactStatesDistinctGet(
        campaignId?: (string | null),
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/admin/contact-states/distinct',
            query: {
                'campaign_id': campaignId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
